import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "Badge"
}
const _hoisted_2 = { class: "RefineContentOptionsList" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DropdownFilter = _resolveComponent("DropdownFilter")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["UniversityFilterWrapper", { 'is-collapsed': _ctx.collapsed }])
  }, [
    _createElementVNode("header", {
      class: "RefineSectionHeading",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleFilter()))
    }, [
      _cache[1] || (_cache[1] = _createElementVNode("i", { class: "lnr-sp-logo FilterIcon" }, null, -1 /* CACHED */)),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "Title" }, "University", -1 /* CACHED */)),
      (_ctx.filterHintCount > 0)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.filterHintCount), 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      _createElementVNode("i", {
        class: _normalizeClass(["ToggleIcon", [_ctx.collapsed ? 'lnr-chevron-down' : 'lnr-chevron-up']])
      }, null, 2 /* CLASS */)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("label", { class: "UniversityFilterLabel" }, "Search by university", -1 /* CACHED */)),
      _createVNode(_component_DropdownFilter, {
        suggest: _ctx.suggest,
        processSelection: _ctx.processSelection,
        lastValidSelectionOption: _ctx.lastValidSelectionOption,
        inputDisplay: _ctx.selectionName,
        filterKey: _ctx.key,
        placeholder: "University name"
      }, null, 8 /* PROPS */, ["suggest", "processSelection", "lastValidSelectionOption", "inputDisplay", "filterKey"])
    ])
  ], 2 /* CLASS */))
}